<br />
<highcharts-chart
  [Highcharts]="Highcharts"
  [constructorType]="chartConstructor"
  [oneToOne]="true"
  [update]="updateFlag"
  [options]="chartOptions"
  [callbackFunction]="chartCallback"
  style="width: 100%; height: 400px; display: block"></highcharts-chart>
